module.exports = __webpack_public_path__ + "static/media/icon21.35d5450a.png";